import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

import { ServiceGroup } from '@/types/serviceGroup';
import { formatError, serviceGroupsApi } from '@/services/api';
import { pages } from '@/settings/pages';

type FetchListPrams = {
  serviceGroupId: ServiceGroup['id'];
};

export const fetchList = createAsyncThunk(
  'organization-service/fetchList',
  async (params: FetchListPrams, { rejectWithValue }) => {
    try {
      const response = await serviceGroupsApi.get({
        data: {
          serviceGroupId: params.serviceGroupId,
        },
      });
      return response;
    } catch (error) {
      if (axios.isAxiosError(error) && error.response !== undefined) {
        const isNotFound = error.response && error.response.status === 404;
        if (isNotFound) window.location.assign(pages.top);
        return rejectWithValue({ error: formatError(error.response) });
      }
      throw error;
    }
  },
);
